import Tareas from './Tareas'

export default Tareas
